import { useEffect, useRef } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export function usePreviousDefined<T>(value?: T) {
  const ref = useRef<T | undefined>(undefined);

  useEffect(() => {
    if (value !== undefined) {
      ref.current = value;
    }
  });

  return value !== undefined ? value : ref.current;
}
